// extracted by mini-css-extract-plugin
export default {"h":"styles_h__bKd5n","p":"styles_p__bzvOV"};